import React from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Box, Grid, Button } from '@mui/material';
import { getRequest, putRequest } from 'Includes/api/apicall';
import { GET_URL, PUT_URL } from 'Includes/urls';
import { Link } from 'react-router-dom';
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import Switch from '@mui/material/Switch';
import Swal from 'sweetalert2'

const disabledIds=[1,2]

function MenuList(props) {

  const { company_id } = props;

  const [rows, setRows] = React.useState([])
  const [rowCount, setRowCount] = React.useState(0)
  const [submitDisable, setSubmitDisable] = React.useState(false)
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  })

  const columns = [
    { field: 'id', headerName: 'ID', width: 90, hide: true},
    {
      field: "is_enabled",
      headerName: "Enabled",
      renderCell: (cellValues) => {
        return (
          <Switch disabled={disabledIds.includes(cellValues['id'])} defaultChecked={cellValues['value']} onChange={() => handleChangeEnable(cellValues)} />
        );
      }
    },
    {
      field: 'menu_name',
      headerName: 'Menu Name',
      width: 150,
    },
  ];

  const handleChangeEnable = (value) => {
    let rows_temp = [...rows]
    setRows(() => [])
    let index = rows_temp.findIndex(function (object) { return object.id === value['id'] });
    rows_temp[index]['is_enabled'] = !value['value']
    setRows(() => rows_temp)
  }

  React.useEffect(() => {
    getMenuList()
  }, [paginationModel.page, paginationModel.pageSize])

  const getMenuList = () => {
    const url = GET_URL.urlsmenu.api + company_id + '/'
    const params = {
      limit: paginationModel.pageSize,
      pageno: paginationModel.page + 1,
    }
    getRequest(url, params, props).then(response => {
      if (response && response.status === 200) {
        const data = response.data.data || []
        setRows(() => data)
        setRowCount(response.data?.count || data.length)
      }
    })
  }

  const getPostFormat = () => {
    let enable = []
    let disable = []
    rows.map((data) => {
      if (data.is_enabled) {
        enable.push(data['id'])
      }
      else {
        disable.push(data['id'])
      }
    })
    return { enable: enable, disable: disable }
  }

  const submit = () => {
    setSubmitDisable(() => true)
    let post_format = getPostFormat()
    const url = PUT_URL.urlsmenu.api + company_id + '/'
    putRequest(url, post_format, {}).then(response => {
      if (response && response.status === 200) {
        const Response = response.data
        Swal.fire({
          position: 'top-end',
          type: 'success',
          title: Response.Reason,
          text: 'School Information is Updated ',
          showConfirmButton: false,
          timer: 1500
        })
      }
      setSubmitDisable(() => false)
    })
  }

  return (
    <Box>
      <div style={{ height: '58vh', width: '100%' }} className='mt-10'>
        <DataGrid
          rows={rows}
          columns={columns}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 25, 100]}
          rowCount={rowCount}
          // checkboxSelection
          disableSelectionOnClick
        />
      </div>
      <Box display='flex' justifyContent='flex-end' className='mt-10'>
        <Button variant='contained'
          color='primary' className='submit'
          disabled={submitDisable}
          onClick={submit}>
          Submit
        </Button>
      </Box>
    </Box>
  )

}

export default MenuList;